module.exports = __webpack_public_path__ + "img/index_img5.69a5c3a8.png";